export default "/images/vendor/flag-icon-css/flags/4x3/jp.svg?19c631c1498ba5517cd5d01823f50e2a";